import { css } from 'aphrodite/no-important';
import React from 'react';
import { Paragraph } from '@trainline/depot-web';
import dayjs from 'dayjs';

import styles from './styles';
import { JourneyLegTrackIcon } from './JourneyLegTrackIcon';

interface Props {
  originStationName: string;
  departureDateTime: string;
  destinationStationName: string;
  arrivalDateTime: string;
}

export const JourneyLeg = ({
  originStationName,
  departureDateTime,
  destinationStationName,
  arrivalDateTime,
}: Props) => (
  <div className={css(styles.journeyLeg)}>
    <ul className={css(styles.track)}>
      <li className={css([styles.trackItemGrid])}>
        <JourneyLegTrackIcon type="origin" />
        <div className={css(styles.trackItemTime, styles.originTime)}>
          <Paragraph as="div" typeStyle="body" fontWeight="bold">
            {dayjs(departureDateTime).format('HH:mm')}
          </Paragraph>
        </div>
        <div className={css(styles.trackItemInfo)}>
          <Paragraph as="span" typeStyle="body" fontWeight="bold">
            {originStationName}
          </Paragraph>
        </div>
      </li>
      <li className={css(styles.trackItemGrid)}>
        <JourneyLegTrackIcon type="destination" />
        <div className={css(styles.trackItemTime)}>
          <Paragraph as="div" typeStyle="body" fontWeight="bold">
            {dayjs(arrivalDateTime).format('HH:mm')}
          </Paragraph>
        </div>
        <div className={css(styles.trackItemInfo)}>
          <Paragraph as="span" typeStyle="body" fontWeight="bold">
            {destinationStationName}
          </Paragraph>
        </div>
      </li>
    </ul>
  </div>
);
